var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 162,
    height: 162,
    viewBox: "0 0 162 162",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_162",
    x: 0,
    y: 0,
    width: 162,
    height: 162,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 6,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.09
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3800",
    "data-name": "Rectangle 3800",
    width: 39.799,
    height: 45.5,
    fill: "#faf6f0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9655",
    "data-name": "Group 9655",
    transform: "translate(1099.379 5387.379) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1, 0, 0, -1, 1099.38, 5387.38)",
    filter: "url(#Ellipse_162)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_162-2",
    "data-name": "Ellipse 162",
    transform: "translate(148.5 142.5) rotate(180)",
    fill: "none",
    stroke: "#faf6f0",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 67.5,
    cy: 67.5,
    r: 67.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67.5,
    cy: 67.5,
    r: 66,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9656",
    "data-name": "Group 9656",
    transform: "translate(1034.279 5335.129) rotate(-180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9651",
    "data-name": "Group 9651",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33774",
    "data-name": "Path 33774",
    d: "M.032,45.48C.02,40.107,0,34.734,0,29.361Q0,14.69.032.02l.1.005L.227,0c2.695,1.512,5.4,3,8.081,4.543,4.3,2.476,8.579,4.987,12.868,7.482q6.344,3.689,12.692,7.37c1.905,1.1,3.835,2.158,5.93,3.335-1.2.7-2.292,1.346-3.392,1.985Q26.973,30.2,17.536,35.679q-7.9,4.569-15.82,9.093c-.478.274-.992.486-1.489.727a.323.323,0,0,0-.2-.02",
    transform: "translate(0)",
    fill: "#faf6f0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/Play_Icon.894609228f75cd33b7700dd9f1af99d0.svg";
export { ForwardRef as ReactComponent };